module.exports = __webpack_public_path__ + "static/media/step2.adc98982.png";